const Title = ({col, country}) => {

    return(
        <h3>{col} {country}</h3>
    )

}

export default Title